import { render, staticRenderFns } from "./RiverPolygonList.vue?vue&type=template&id=5af4b4ce&scoped=true"
import script from "./RiverPolygonList.vue?vue&type=script&lang=js"
export * from "./RiverPolygonList.vue?vue&type=script&lang=js"
import style0 from "./RiverPolygonList.vue?vue&type=style&index=0&id=5af4b4ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af4b4ce",
  null
  
)

export default component.exports